<!-- This component is a container for advance search providing the basic container for advance search  -->
<!-- Items it consist of is  1. Input field for normal search 2. Advance Search container view 3. Search Params Text 4. Clear Search and Search button -->

<template>
  <v-row no-gutters>
    <v-col :data-test-id="parentDataTestId">
      <AdvanceSearchBar
        :primaryColor="primaryColor"
        :parentDataTestId="parentDataTestId"
        @searchData="searchData"
        @cancelSearch="cancelSearch"
      />
      <AdvanceSearchLabel
        :openadvanceSearch="openadvanceSearch"
        :parentDataTestId="parentDataTestId"
        @toggleAdvanceSearch="toggleAdvanceSearch"
      />
      <AdvanceSearchForm
        :openadvanceSearch="openadvanceSearch"
        :primaryColor="primaryColor"
        :parentDataTestId="parentDataTestId"
        @cancelSearch="cancelSearch"
        @searchData="searchData"
      >
        <template slot="advance_search_items">
          <slot name="advance_search_items"></slot>
        </template>
      </AdvanceSearchForm>
      <AdvanceSearchFiltersBox
        :showSearchItems="showSearchItems"
        :searchItems="searchItems"
        :data-test-id="`${parentDataTestId}__filters-container`"
        @removeSearchItem="removeSearchItem($event)"
        @cancelSearch="cancelSearch"
      />
    </v-col>
  </v-row>
</template>
<script>
import AdvanceSearchBar from '@/components/AdvanceSearch/AdvanceSearchBar';
import AdvanceSearchLabel from '@/components/AdvanceSearch/AdvanceSearchLabel';
import AdvanceSearchForm from '@/components/AdvanceSearch/AdvanceSearchForm';
import AdvanceSearchFiltersBox from '@/components/AdvanceSearch/AdvanceSearchFiltersBox';
import SearchCriteriaChipHelper from '@/helpers/SearchCriteriaChipHelper';
import { mapState } from 'vuex';
export default {
  components: {
    AdvanceSearchFiltersBox,
    AdvanceSearchBar,
    AdvanceSearchForm,
    AdvanceSearchLabel
  },
  props: {
    primaryColor: String,
    searchParams: [Object, String],
    expanded: Boolean,
    parentDataTestId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      searchIcon: false,
      openadvanceSearch: this.expanded,
      searchText: '',
      showSearchItems: false,
      searchObject: {},
      searchItems: []
    };
  },
  computed: {
    ...mapState(['currentlySelectedOrgId'])
  },
  watch: {
    currentlySelectedOrgId: function() {
      this.cancelSearch();
    },
    searchParams: function() {
      if (this.searchParams) {
        const chipHelper = new SearchCriteriaChipHelper();
        this.searchItems = chipHelper.getSearchCriteriaChips(this.searchParams);
        this.showSearchItems = true;
      }
    }
  },
  methods: {
    toggleAdvanceSearch() {
      this.openadvanceSearch = !this.openadvanceSearch;
      this.showSearchItems = !this.openadvanceSearch;
    },
    searchData(searchText) {
      if (searchText) {
        this.searchText = searchText;
      }
      this.showSearchItems = true;
      if (!this.searchText && !this.openadvanceSearch) {
        return;
      }
      this.$emit('getSearchObject', {
        searchObject: this.searchObject,
        searchText: this.searchText,
        quickSearch: !this.openadvanceSearch
      });

      this.searchText = '';

      this.openadvanceSearch = false;
    },
    removeSearchItem({ item, index }) {
      this.searchItems.splice(index, 1);
      this.$emit('getSearchObject', {
        searchObject: this.searchObject,
        searchText: this.searchText,
        quickSearch: !this.openadvanceSearch,
        removeItem: item.id
      });
    },

    cancelSearch() {
      this.searchText = '';
      this.openadvanceSearch = false;
      this.$emit('clearAllData', true);
      this.clearAll();
    },
    clearAll() {
      this.showSearchItems = false;
      this.$nextTick(() => {
        this.searchItems = [];
      });
    }
  }
};
</script>

<style scoped>
.v-icon {
  cursor: pointer;
}
.advance-search-container {
  /* background: #5be7c4; */
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
}
.slideup,
.slidedown {
  min-height: 0;
  overflow-y: hidden;
  -webkit-transition: min-height 0.5s ease-in-out;
  -moz-transition: min-height 0.5s ease-in-out;
  -o-transition: min-height 0.5s ease-in-out;
  transition: min-height 0.5s ease-in-out;
}
.slidedown {
  min-height: 60px;
}
.v-input__control .v-input__slot {
  margin-bottom: 0px;
}
</style>
<style>
.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.06);
}
</style>
